import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const NameSummaryFormUS = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['name'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const salutationField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'salutation'),
    message: s.dataSummary.requiredMessage!,
  });
  const salutationLabel = translate(salutationField?.label);
  const salutationValue =
    translate(salutationField?.options?.find(({ value }) => value === getFieldValue('salutation'))?.label) ||
    getFieldValue('salutation');

  const firstNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'firstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const firstNameLabel = translate(firstNameField?.label);

  const lastNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'lastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const lastNameLabel = translate(lastNameField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-name'}>
      <h2>{translate(s.dataSummary.titles?.name)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{firstNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('firstname')}
          {editMode && <EditDataField slideId={'name'} field={firstNameField!} />}
        </div>

        <div className={'label'}>{lastNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('lastname')}
          {editMode && <EditDataField slideId={'name'} field={lastNameField!} />}
        </div>

        <div className={'label'}>{salutationLabel}</div>
        <div className={'value'}>
          {!editMode && salutationValue}
          {editMode && <EditDataField slideId={'name'} field={salutationField!} />}
        </div>
      </div>
    </div>
  );
};
